import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6328eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-chapter"]


const __default__ = {
  name: 'ChapterSections',
};

import {
  PropType,
  onMounted,
  onUnmounted,
  ref,
} from 'vue';

import { useStore } from '@/store';
import chapters from '@/chapters';
import Chapter from './Chapter.vue';

interface Cache {
  el: HTMLElement;
  y: number;
  height: number;
  start: number;
  done: boolean;
  chapterNumber?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  transition: Function as PropType<(event: Event, id: string | number) => void>,
},
  setup(__props) {



const store = useStore();
const chapterElements = ref<HTMLElement[]>([]);
const cache = ref<Cache[]>([]);
const doc = document.documentElement;
const h = window.innerHeight;

const onScroll = () => {
  const st = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  const { currentChapter } = store.state.status;
  let isActive = false;

  for (let i = 0; i < cache.value.length; i += 1) {
    const item = cache.value[i];
    // const itemY = this.ignoreCache ? item.el.getBoundingClientRect().top : item.y;
    // const itemHeight = this.ignoreCache ? item.el.clientHeight : item.height;
    const itemY = item.y;
    const itemHeight = item.height;
    const yBottom = st + ((1 - item.start) * h);

    if (itemY <= yBottom && itemY + itemHeight >= st) {
      isActive = true;

      if (!item.done) {
        store.dispatch('setCurrentChapter', item.chapterNumber);
        item.done = true;
      }
    } else if (item.done) {
      item.done = false;
    }
  }

  if (currentChapter && !isActive) {
    store.dispatch('setCurrentChapter', undefined);
  }
};

onMounted(() => {
  window.addEventListener('scroll', onScroll);
  const elements = [...document.querySelectorAll<HTMLElement>('[data-chapter]')];
  chapterElements.value = elements;

  elements.forEach(element => {
    cache.value.push({
      el: element,
      y: element.getBoundingClientRect().top + window.scrollY,
      start: 0.5,
      height: element.clientHeight,
      chapterNumber: element.dataset.chapter,
      done: false,
    });
  });
});

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapters), (item, index) => {
    return (_openBlock(), _createElementBlock("section", {
      class: _normalizeClass(["chapter-section", item.theme ==='dark' ? 'u-dark' : 'u-light']),
      "data-chapter": index + 1,
      key: index
    }, [
      _createVNode(Chapter, {
        data: item.data,
        transition: __props.transition,
        title: item.title,
        theme: item.theme,
        chapterNumber: index + 1
      }, null, 8, ["data", "transition", "title", "theme", "chapterNumber"])
    ], 10, _hoisted_1))
  }), 128))
}
}

})